<template>
	<div>
		<StateBar class="w-75p" />
		<h2 class="fs-title text-center">Alap- és kiegészítőcsomag tájékoztató</h2>
		<CalcElements :elements="computedElements" />
		<NavButtons
			:prevLink="prevLink"
			:nextLink="nextLink"
			:nextText="nextText"
			@next="handleNext"
			@prev="onPrev"
			:loading="loading"
		/>
	</div>
</template>

<script>
import PackageInformation from '@json/PackageInformation.json';
import CalcElements from '@/components/CalcElements.vue';
import NavButtons from '@/components/NavButtons.vue';
import validation from '@/mixins/validation';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import _ from 'lodash';

export default {
	mixins: [validation],
	async mounted() {
		await this.fetchInsuranceEvents();
	},
	data() {
		return {
			elements: PackageInformation,
			content: '',
			show: false,
			prevLink: 'contract-details',
			nextLink: 'comparison',
			nextText: 'Összehasonlítás',
			loading: false,
		};
	},
	components: {
		CalcElements,
		NavButtons,
	},
	methods: {
		...mapActions(['fetchInsuranceEvents', 'saveCalculationData', 'calculate']),
		...mapMutations(['cloneEvents']),
		async handleNext() {
			this.loading = true;
			this.cloneEvents();
			await this.saveCalculationData();
			await this.calculate();
			this.loading = false;
			this.onSubmit(false);
		},
	},
	computed: {
		...mapGetters(['getInsuranceEvents']),
		...mapGetters('auth', ['isLoggedIn', 'isVerified', 'isUser']),
		computedElements() {
			let elements = _.cloneDeep(PackageInformation);
			let basic = _.map(_.cloneDeep(this.getInsuranceEvents.basic), basicEvent => {
				basicEvent.text = basicEvent.name;
				basicEvent.className = '';
				basicEvent.wrapperClass = 'w-100';
				basicEvent.tooltip = true;
				basicEvent.tooltipText = basicEvent.hint;

				return basicEvent;
			});
			let extend = _.map(_.cloneDeep(this.getInsuranceEvents.extend), extendEvent => {
				extendEvent.type = 'event';
				extendEvent.label = extendEvent.name;
				extendEvent.className = '';
				extendEvent.wrapperClass = 'col-w100-chbox chbox_style-wrapper';
				extendEvent.inputClass =
					'col-w100-chbox chbox_style-wrapper w-50 mobile-width-full h-46px h-46px-mobile';
				extendEvent.tooltip = extendEvent.hint !== null && extendEvent.hint !== '';
				extendEvent.tooltipText = extendEvent.hint;
                if(extendEvent.name === "Értéktágy kiegészítő biztosítás") {
                    extendEvent.disabled = true;
                }
				return extendEvent;
			});

			extend = _.keyBy(_.sortBy(extend, 'id'), 'id');
			basic = _.keyBy(_.sortBy(basic, 'id'), 'id');
			extend[0] = elements.groupElements2.elements.title;

			elements.groupElements1.elements.lists.basicPackage = basic;
			elements.groupElements2.elements = extend;

			return elements;
		},
	},
};
</script>
